import { DTO__image_crop_box } from '@shared/dto/+image/image_asset_base/DTO__image_crop_box';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../_base/FIELD__base';
import { DECORATOR__class_serialization_tested_for_hash } from '../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../_primitives/_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';

@DECORATOR__class_serialization_tested_for_hash
export class FIELD__image_crop_box extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_IMAGE_CROP_BOX;

  /*
   * FIELDS META
   */
  _image_size_original!: DTO__image_size;
  _target_aspect_ratio!: number;

  crop_box!: DTO__image_crop_box;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.IMAGE_CROP_BOX;
  }

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.crop_box.toString();
  }

  get image_size_original() {
    return this._image_size_original;
  }

  set image_size_original(value: DTO__image_size) {
    if (this._image_size_original.is_equal(value)) return;

    this._image_size_original = value;

    this.crop_box__init();
  }

  get target_aspect_ratio() {
    return this._target_aspect_ratio;
  }

  set target_aspect_ratio(value: number) {
    if (this._target_aspect_ratio == value) return;

    this._target_aspect_ratio = value;

    this.crop_box__init();
  }

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super();

    this._image_size_original = DTO__image_size.CREATE_STUB();
    this._target_aspect_ratio = NaN;

    this.crop_box__init();
  }

  crop_box__init() {
    if (this._image_size_original.is_stub()) {
      this.crop_box__clear();
    } else if (Number.isNaN(this._target_aspect_ratio)) {
      this.crop_box__clear();
    } else {
      this.crop_box = DTO__image_crop_box.create_first_crop_box_for_image(this._image_size_original, this._target_aspect_ratio);
    }
  }

  crop_box__clear() {
    this.crop_box = DTO__image_crop_box.ZERO.clone();
  }

  /*
   * HASH
   */

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.crop_box.is_zero()) return false;
    if (this.crop_box.is_stub()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  /*
   * SYNC VALUE
   */

  /*
   * VALIDATIONS
   */

  /*
   * ASSERTS
   */

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = ['crop_box'];

    return out as string[];
  }
}
